export default (function (_ref) {
  var request = _ref.request;
  return {
    feedBaitScheduledTaskQuery: function feedBaitScheduledTaskQuery(data) {
      return request({
        url: '/iot/feedBaitScheduledTask',
        method: 'get',
        params: data
      });
    }
  };
});